export const API = 'https://bethelspa.misionweb.com'